import init from './methods/init';

export default {
    init,
}
